import React from "react";
import Button from "../primitives/Button";
import Container from "../Common/Container";
import { CalloutProps } from "./interfaces/Callout";
import parse from "html-react-parser";
import Text from "../Common/Text";
import Image from "../Common/Image";

const defaultData: CalloutProps = {
  image: {
    desktop:
      "https://assets.dogtorsoftware.com/25/website/d47ed3ae-41df-4bcb-a728-5d03187d94e3.png",
  },
  title: { value: "Título de ejemplo" },
  description: "<p>Esta es la descrición</p>",
  button: {
    name: "Conocer más",
    url: "#",
  },
};

const Callout = ({
  data = defaultData,
  onChange,
  ImageProvider,
}: {
  data?: CalloutProps;
  onChange?: (value: any, id: string) => void;
  ImageProvider: any;
}) => {
  return (
    <Container>
      <div
        id="CalloutRow"
        className={`bg-[--primary100] rounded-[--border-radius] p-10 my-10 md:grid grid-cols-2  gap-10`}
      >
        <div
          id="CalloutContainerImage"
          className={`${data?.alling === "RIGHT" ? "order-1" : "order-2"}`}
        >
          <Image
            id="Callout"
            {...data.image}
            className="w-full h-auto"
            ImageProvider={ImageProvider}
            height="auto"
            width="100%"
          />
        </div>

        <div
          id="CalloutContainerText"
          className={` ${
            data?.alling === "RIGHT" ? "order-2" : "order-1"
          } mt-5 md:mt-0`}
        >
          <Text
            editor={!!onChange}
            id="Callout"
            onChange={(val: any) => onChange?.(val, "title")}
          >
            {data?.title}
          </Text>

          <Button {...data?.button} className="mt-5"></Button>
        </div>
      </div>
    </Container>
  );
};

export default Callout;
